// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"23590671","885":"d6531e7f"}[chunkId] + ".chunk.js";
};